import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { doRequest } from "../utils/helper";

export default function DashboardNumber({ userData }) {
  const [data, setData] = useState({
    total_user: null,
    active_user: null,
    inactive_user: null,
    unlimited_plan: null,
    pay_as_plan: null,
    free_plan: null,
    yearly_plan: null,
    total_variation: 0,
    active_plan_user: 0,
    inactive_plan_user: 0
  });

  const getUserData = async (type) => {
    try {
      let url = `user/list?page=1&status=${type ? type : ""}&limit=40`;
      let response = await doRequest("", "GET", url);
      if (+response?.resultFlag === 1) {
        if (type === "active") {
          setData((prev) => ({
            ...prev,
            active_user: response?.response?.totalRecords,
          }));
        } else if (type === "inactive") {
          setData((prev) => ({
            ...prev,

            inactive_user: response?.response?.totalRecords,
          }));
        } else {
          setData((prev) => ({
            ...prev,
            total_user: response?.response?.totalRecords,
          }));
        }
      }
    } catch (error) {}
  };

  const getPlanData = async (id) => {
    try {
      let url = `user/list_usersby_blan?plan_id=${id ? id : ""}`;
      let response = await doRequest("", "GET", url);
      if (+response?.resultFlag === 1) {
        if (+id === 6) {
          setData((prev) => ({
            ...prev,
            unlimited_plan: response?.response?.totalRecords,
          }));
        } else if (+id === 5) {
          setData((prev) => ({
            ...prev,

            pay_as_plan: response?.response?.totalRecords,
          }));
        } else if (+id === 1) {
          setData((prev) => ({
            ...prev,
            free_plan: response?.response?.totalRecords,
          }));
        } else if (+id === 7) {
          setData((prev) => ({
            ...prev,
            yearly_plan: response?.response?.totalRecords,
          }));
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    callAllApi();
  }, []);

  const callAllApi = async () => {
    let userTotalFunc = getUserData();
    let userActiveFunc = getUserData("active");
    let userInactiveFunc = getUserData("inactive");
    let unlimitedPlanFunc = getPlanData(6);
    let pasAsPlanFunc = getPlanData(5);
    let FreePlanFunc = getPlanData(1);
    let yearlyPlanFunc = getPlanData(7);
    await Promise.all([
      userTotalFunc,
      userActiveFunc,
      userInactiveFunc,
      unlimitedPlanFunc,
      pasAsPlanFunc,
      FreePlanFunc,
      yearlyPlanFunc,
    ]);
  };
  return (
    <>
      <div className="dashboard_card">
        <ul className="dashboard_list">
          <li>
            <div className="dashboard_num">
              <h3>{data?.total_user}</h3>
              <h5>Total Users</h5>
              <Link
                to={`/userlist?type=totaluser&totalcount=${data?.total_user}`}
                className="view_link"
              >
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>

          <li>
            <div className="dashboard_num">
              <h3>{userData?.active_plan_user}</h3>
              <h5>Active Users</h5>
              <Link
                to={`/userlist?type=activeuser&totalcount=${userData?.active_plan_user}`}
                className="view_link"
              >
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>
          
          <li>
            <div className="dashboard_num">
              <h3>{userData?.inactive_plan_user}</h3>
              <h5>InActive Users</h5>
              <Link
                to={`/userlist?type=inactiveuser&totalcount=${userData?.inactive_plan_user}`}
                className="view_link"
              >
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>


          <li>
            <div className="dashboard_num">
              <h3>{userData?.blocked_user}</h3>
              <h5>Blocked Users</h5>
              <Link
                to={`/userlist?type=blockeduser&totalcount=${userData?.blocked_user}`}
                className="view_link"
              >
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>

          <li>
            <div className="dashboard_num">
              <h3>{data?.unlimited_plan}</h3>
              <h5>Unlimited Plan</h5>
              <Link
                to={`/userlist?type=unlimitedplan&totalcount=${data?.unlimited_plan}`}
                className="view_link"
              >
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>

          <li>
            <div className="dashboard_num">
              <h3>{data?.pay_as_plan}</h3>
              <h5>Pay As You Plan</h5>
              <Link
                to={`/userlist?type=payasplan&totalcount=${data?.pay_as_plan}`}
                className="view_link"
              >
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>

          <li>
            <div className="dashboard_num">
              <h3>{data?.free_plan}</h3>
              <h5>FREE PLAN</h5>
              <Link
                to={`/userlist?type=freeplan&totalcount=${data?.free_plan}`}
                className="view_link"
              >
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>
          <li>
            <div className="dashboard_num">
              <h3>{data?.yearly_plan}</h3>
              <h5>Yearly Plan</h5>
              <Link
                to={`/userlist?type=yearlyplan&totalcount=${data?.yearly_plan}`}
                className="view_link"
              >
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>

          <li>
            <div className="dashboard_num">
              <h3>{userData?.total_variants}</h3>
              <h5>Total Variations</h5>
              <Link to="#" className="view_link">
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}
